export enum FlightTypeEnum {
  ONEWAY = "ONEWAY",
  ROUNDWAY = "ROUNDWAY",
  MULTICITY = "MULTICITY",
}
